// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9cc56ab6","502":"267daa08","614":"c340cdf3","997":"70630024"}[chunkId] + ".chunk.js";
};